import ContentLoader from '@rio-cloud/rio-uikit/ContentLoader';

import TotalCard from '@/components/ui/TotalCard';
import CustomExpanderPanel from '@/features/chargingCards/history/CustomExpanderPanel';

const OrderHistorySummaryLoader = () => (
    <div className='margin-bottom-25 margin-top-10 display-flex width-100pct gap-20'>
        {['totalOrders', 'totalCardsOrdered', 'totalCardsInProduction', 'totalCardsShipped'].map(key => (
            <div key={key} className='panel panel-default width-25pct margin-bottom-0'>
                <TotalCard
                    title={
                        <span className='display-flex justify-content-center width-100pct'>
                            <ContentLoader height={30} width='60%' />
                        </span>
                    }
                >
                    <ContentLoader height={30} width='20%' />
                </TotalCard>
            </div>
        ))}
    </div>
);

const OrderHistoryFilterLoader = () => (
    <div className='display-flex align-items-end width-100pct margin-bottom-20'>
        <div
            className='display-flex flex-column gap-2'
            style={{ width: 'calc((100% - 60px) / 4)' }}
            data-testid='filter-loader'
        >
            <ContentLoader height={16} width='30%' />
            <ContentLoader height={34} width='100%' />
        </div>
        <div
            className='display-flex flex-column gap-2 margin-left-20'
            style={{ width: 'calc((100% - 60px) / 4)' }}
            aria-hidden='true'
        >
            <ContentLoader height={16} width='30%' />
            <ContentLoader height={34} width='100%' />
        </div>
        <div className='display-flex margin-left-auto align-self-end' aria-hidden='true' data-testid='support-loader'>
            <ContentLoader height={34} width={120} className='margin-bottom-0' />
        </div>
    </div>
);

export type OrderHistoryLoaderProps = {
    showSummary?: boolean;
    showFilter?: boolean;
};

const OrderHistoryLoader = ({ showSummary = false, showFilter = false }: OrderHistoryLoaderProps) => {
    const body = (
        <div className='display-flex justify-content-between'>
            <div className='display-flex'>
                <div className='display-flex flex-column gap-2'>
                    <ContentLoader height={20} width='50%' />
                    <ContentLoader height={14} width='35%' />
                </div>
            </div>
            <div className='display-flex'>
                <div className='display-flex flex-column gap-2'>
                    <ContentLoader height={20} width='50%' />
                    <ContentLoader height={14} width='35%' />
                </div>
            </div>
            <div className='display-flex'>
                <div className='display-flex flex-column gap-2'>
                    <ContentLoader height={20} width='50%' />
                    <ContentLoader height={14} width='35%' />
                </div>
            </div>
            <div className='display-flex'>
                <div className='display-flex flex-column gap-2'>
                    <ContentLoader height={20} width='50%' />
                    <ContentLoader height={14} width='35%' />
                </div>
            </div>
            <div className='display-flex'>
                <div className='display-flex flex-column gap-2'>
                    <ContentLoader height={20} width='50%' />
                    <ContentLoader height={14} width='35%' />
                </div>
            </div>
            <div className='flex-basis-5pct' />
        </div>
    );

    return (
        <div>
            {showSummary ? <OrderHistorySummaryLoader /> : null}
            {showFilter ? <OrderHistoryFilterLoader /> : null}
            <CustomExpanderPanel header={<ContentLoader height={20} width='100%' />} body={body} isDisabled />
            <CustomExpanderPanel header={<ContentLoader height={20} width='100%' />} body={body} isDisabled />
            <CustomExpanderPanel header={<ContentLoader height={20} width='100%' />} body={body} isDisabled />
        </div>
    );
};

export default OrderHistoryLoader;
